export const idpw = {
  email: "lastexit0710@gmail.com",
  pw: "1q2w3e4r!@#",
};
